export const ROLES = {
  EDITOR: 'editor',
  VIEWER: 'viewer',
};
